<template>
    <div class="animated fadeIn pr-4">
        <div class="col-md-12 pr-0">
            <div v-if="showWelcomeBanner" class="row welcome-banner mb-4">
                <div class="col-12 d-flex justify-content-between align-items-start">
                    <div>
                        <h3>{{ welcomeGreeting }}, {{ userName }}!</h3>
                        <p class="text-muted">{{ $t('SUMMARYOFYOURPROPERIES') }}</p>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="quick-stats d-flex text-center mr-4">
                            <div class="stat-item">
                                <div class="stat-value">{{ totalBuildings }}</div>
                                <div class="stat-label">{{ $t('TOTALBUILDINGS') }}</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-value text-danger">{{ totalCriticalIssues }}</div>
                                <div class="stat-label">{{ $t('CRITICALISSUES') }}</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-value text-warning">{{ totalOverdueJobs }}</div>
                                <div class="stat-label">{{ $t('OVERDUEJOBS') }}</div>
                            </div>
                            <button type="button" class="close ml-3" aria-label="Close" @click="showWelcomeBanner = false">
                                <span aria-hidden="true" style="font-size: 36px;">&times;</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row ">
        <div class="col-md-12 pr-0">
            <div class="row ">
                <div class="col-md-12">
                    <div class="buttons-group mb-3">

                        <label class="has-float-label mr-2" v-if="globals.groupId === 1 || globals.globals === 5">
                            <b-form-fieldset v-bind:label="$t('USERCOMPANIES')">
                                <lbselect 
                                    :empty="true" 
                                    :list="companyData.root" 
                                    :total-count="companyData.totalCount"
                                    :pagination="paginationCompany"
                                    v-on:reload="getCompanyData()"
                                    v-model="pagination.companyId" 
                                    value-field="companyId" 
                                    display-field="companyName">
                                </lbselect>
                            </b-form-fieldset>
                        </label>

                        <label class="has-float-label mr-2" v-if="(globals && globals.acl && globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.insertAction)">
                            <b-form-fieldset v-bind:label="$t('USERSUBCOMPANIES')">
                                <lbselect 
                                    :empty="true" 
                                    :list="subCompanyData.root" 
                                    :total-count="subCompanyData.totalCount"
                                    :pagination="paginationSubCompany"
                                    v-on:reload="getSubCompanyData()"
                                    v-model="pagination.subCompanyId" 
                                    value-field="subCompanyId" 
                                    display-field="subCompanyName">
                                </lbselect>
                            </b-form-fieldset>
                        </label>

                        <label class="has-float-label mr-2" v-if="(globals && globals.acl && globals.acl.BuildingDetail && globals.acl.BuildingDetail.insertAction)">
                            <b-form-fieldset v-bind:label="$t('CLIENT')">
                                <lbselect 
                                    :empty="true" 
                                    :list="building.root" 
                                    :total-count="building.totalCount"
                                    :pagination="paginationBuilding"
                                    v-on:reload="getBuildingData()"
                                    v-model="pagination.buildingDetailId" 
                                    value-field="buildingDetailId" 
                                    display-field="clientName">
                                </lbselect>
                          </b-form-fieldset>
                        </label>

                        <label class="has-float-label mr-2">
                            <b-form-fieldset>
                                <span>{{$t('ADDRESS')}}</span>
                                <input class="form-control" placeholder=" " v-model="pagination.address">
                            </b-form-fieldset>
                        </label>

                        <label class="has-float-label mr-2">
                            <b-form-fieldset v-bind:label="$t('STATUS')">
                                <b-form-select :class="`form-control select-${pagination.status}`" v-model="pagination.status">
                                    <b-form-select-option 
                                        v-for="item in status" 
                                        :key="item.value" 
                                        :value="item.value"
                                        :class="`select-${item.value}`">
                                        {{ item.text.toUpperCase() }}
                                    </b-form-select-option>
                                </b-form-select>
                            </b-form-fieldset>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row ">
                <template v-for="item in data.root">
                <div class="col-lg-2 col-md-4 col-sm-6 d-flex dashboard-cursor pr-0" :key="item.buildingDetailId" @click="goTo(item)">
                    <div class="dashboard-widget">
                        <div class="card-statistic-3 p-2">
                            <div class="widget-title-wrapper">
                                <h2 class="widget-title">{{item.clientName}}</h2>
                                <div v-if="item.criticalAttentionCount" class="widget-title-icon-wrapper">
                                    <icon icon="warning" style="color: #9c1c2b"></icon>
                                    <h5 class="widget-title-critical-text">
                                        {{ item.criticalAttentionCount }}
                                    </h5>
                                </div>
                            </div>
                            <h5 class="widget-address">{{item.address}}</h5>
                            <h5 class="widget-address">{{item.city}}</h5>
                            <div class="d-flex flex-wrap">
                                <template v-for="(count, keySec) in item.jobStatuses">
                                    <div v-if="count.cnt" :key="keySec">
                                        <div :class="`dashboard-status-item dashboard-status-item-${count.status}`" style="display: flex; align-items-center; gap: 6px;">
                                            <icon v-if="count.status === 'partialyfinished'" icon="wrench" style="color: #2e5c31"></icon>
                                            <h5>
                                                {{count.cnt}} {{$t(count.status.toUpperCase())}}
                                            </h5>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                </template>
            </div>
        </div>
    </div>
    </div>
</template>
  
<script>
import { mapGetters } from 'vuex';
import Api from '@/api/admin/Dashboard.js';
import BuildingApi from '@/api/building_detail/BuildingDetail.js';
import SubCompanyApi from '@/api/admin/UserSubCompanies.js';
import CompanyApi from '@/api/admin/UserCompanies';

export default
{
    name: 'dashboard',
    data()
    {
        const me = this;

        return {
            data: {},
            search: '',
            building: {},
            companyData: {},
            subCompanyData: {},
            initialDashboardData: {},
            isInitialLoad: true,
            paginationBuilding: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            paginationSubCompany: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            paginationCompany: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            pagination: {
                buildingDetailId: null,
                subCompanyId: null,
                companyId: null,
                address: '',
                status: null,
                currentPage: 1,
                limit: 25,
            },
            status:
            [
                {
                value: null,
                text: me.$i18n.t('SHOWALL'),
                },
                {
                value: 'pending',
                text: me.$i18n.t('PENDING'),
                },
                {
                value: 'active',
                text: me.$i18n.t('ACTIVE'),
                },
                {
                value: 'overdue',
                text: me.$i18n.t('OVERDUE'),
                },
                {
                value: 'finished',
                text: me.$i18n.t('FINISHED'),
                },
                {
                value: 'partialyfinished',
                text: me.$i18n.t('PARTIALYFINISHED'),
                },
                {
                value: 'canceled',
                text: me.$i18n.t('CANCELED'),
                },
                {
                value: 'decline',
                text: me.$i18n.t('DECLINE'),
                },
                {
                value: 'criticalattention',
                text: me.$i18n.t('CRITICALATTENTION'),
                }
            ],
            searchTimeout: false,
            showWelcomeBanner: true,
        };
    },
    created()
    {
        const me = this;
        me.getBuildingData();
        me.getSubCompanyData();
        me.getCompanyData();
        me.getData();
    },
    methods:
    {
        goTo(item)
        {
            const me = this;

            const queryParams = {
                buildingDetailId: item.buildingDetailId,
                address: item.address,
                city: item.city,
                status: me.pagination.status,
                subCompanyId: me.pagination.subCompanyId,
                companyId: me.pagination.companyId,
            };

            Object.keys(queryParams).forEach(key => (queryParams[key] == null || queryParams[key] === '') && delete queryParams[key]);

            me.$router.push({
                path: `/job`,
                query: queryParams,
            });
        },
        async getData()
        {
            const me = this;
            try
            {
                me.loading = true;
                const data = await Api.getDashboardData(me.getParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.data = data;

                if (me.isInitialLoad)
                {
                    me.initialDashboardData = data;
                    me.isInitialLoad = false;
                }
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
            finally
            {
                me.loading = false;
            }
        },
        async getBuildingData()
        {
            const me = this;
            try
            {
                me.loading = true;
                const data = await BuildingApi.selectRow(me.getParamsBuilding);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.building = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
            finally
            {
                me.loading = false;
            }
        },
        async getSubCompanyData()
        {
            const me = this;
            try
            {
                me.loading = true;
                const data = await SubCompanyApi.selectRow(me.getParamsSubCompany);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.subCompanyData = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
            finally
            {
                me.loading = false;
            }
        },
        async getCompanyData()
        {
            const me = this;
            try
            {
                me.loading = true;
                const data = await CompanyApi.selectRow(me.getParamsCompany);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.companyData = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
            finally
            {
                me.loading = false;
            }
        },
    },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;
                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }
                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getParams()
        {
            const me = this;
            const data = { ...me.pagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        getParamsBuilding()
        {
            const me = this;
            const data = { ...me.paginationBuilding };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        getParamsSubCompany()
        {
            const me = this;
            const data = { ...me.paginationSubCompany };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        getParamsCompany()
        {
            const me = this;
            const data = { ...me.paginationCompany };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        userName() {
            return this.globals.username;
        },
        welcomeGreeting() {
            const me = this;
            const hour = new Date().getHours();
            if (hour < 12) return me.$t('GOODMORNING');
            if (hour < 18) return me.$t('GOODAFTERNOON');
            return me.$t('GOODEVENING');
        },
        formattedDate() {
            return new Date().toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        totalBuildings() {
            return this.initialDashboardData.root ? this.initialDashboardData.root.length : 0;
        },
        totalCriticalIssues() {
            if (!this.initialDashboardData.root) return 0;
            return this.initialDashboardData.root.reduce((total, item) => total + (item.criticalAttentionCount || 0), 0);
        },
        totalOverdueJobs() {
            if (!this.initialDashboardData.root) return 0;
            return this.initialDashboardData.root.reduce((total, item) => {
                const overdueStatus = item.jobStatuses.find(status => status.status === 'overdue');
                return total + (overdueStatus ? overdueStatus.cnt : 0);
            }, 0);
        }
    }
};
</script>